export const getCategoryDiscription = (
	category,
	options = { maxLength: 50 }
) => {
	const getDescriptionFromChildren = (bound) => {
		let subCategories = category.attributes.children.slice(0, bound);
		return subCategories.map((item) => item.name).join('، ') + ' و...';
	};

	let description = '';
	if (category?.attributes?.children?.length) {
		let bound = 8;
		do {
			description = getDescriptionFromChildren(bound);
			bound--;
		} while (description.length > options.maxLength && bound > 0);
	}

	return description;
};
